import React, { useState, useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from "axios";
import { endpoints } from "../../services/apiurl";
import PageTitle from "../UI/PageTitle";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
    TextField,
    MenuItem,
    FormControl,
    InputLabel,
    Select,
    Box,
    Grid,
    Paper,
    Container, Typography
  } from '@mui/material';
function AddPaidResvaertion() {
  
  const daysOfWeek = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday'
  ];

 
  const statuses = [
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Inactive' }
  ];
  

    
  useEffect(() => {
  }, []);

    const [selectedDay, setSelectedDay] = useState('');
  const [selectedTime, setSelectedTime] = useState('');
  const [rest, setRest] = useState([]);
  const [value, setvalue] = useState([]);
  const [loading, setloading] = useState(false);

  const onInputChange = (e) => {
    setvalue({[e.target.name]: e.target.value });
  };

  const handleDayChange = (event) => {
    setSelectedDay(event.target.value);
  };

  const handleTimeChange = (event) => {
    setSelectedTime(event.target.value);
  };


  return (
    (
      <Container>
        <Typography variant="h4" gutterBottom>
          Weekly Schedule
        </Typography>
        <Paper
  
          >
        <div className="mt-4">
        {daysOfWeek.map((day) => (
  
            <Grid container spacing={2} alignItems="center" className="px-3" style={{ padding: '5px', marginBottom: '5px' }}>
              <Grid item xs={3}>
                <TextField
                  label="Day"
                  defaultValue={day}
                  InputProps={{
                    readOnly: true,
                  }}
                  variant="outlined"
                  fullWidth
                />
              </Grid>

              <Grid item xs={2}>
                <TextField
                  label="Start Time"
                  type="time"
                  name="start_time"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    step: 300,
                    style: { cursor: 'pointer' },
                    
                  }}
                  variant="outlined"
                  fullWidth
                  onClick={(e) => e.target.showPicker()}
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  label="End Time"
                  type="time"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    step: 300,
                    style: { cursor: 'pointer' },
                  }}
                  variant="outlined"
                  fullWidth
                  onClick={(e) => e.target.showPicker()}
                />
              </Grid>

              <Grid item xs={2}>
                <TextField
                  label="Amount"
                  type="number"
                  variant="outlined"
                  fullWidth
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  label="Status"
                  select
                  onChange={e => onInputChange(e)}
                  variant="outlined"
                  fullWidth
                >
                  <MenuItem value="">
                    <em>Select Status</em>
                  </MenuItem>
                  {statuses.map((option) => (
                    
                    <MenuItem key={option.value} value={option.value} >
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            </Grid>
       
        ))}
             <div className="row ">
                        <div className="col col-6">
                            <div className="py-3 px-2">
                                <LoadingButton
                                    type="submit"
                                    loading={loading}
                                    loadingPosition="start"
                                    startIcon={<SaveIcon />}
                                    variant="contained"
                                    size="large"
                                >
                                    Save
                                </LoadingButton>
                                <ToastContainer />

                            </div></div></div>
        </div>
        </Paper>
    
      </Container>
    )
  )
}

export default AddPaidResvaertion